var _Path, _Path2, _Path3, _Path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgFeedVinyl = function SvgFeedVinyl(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 59 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 22.5V7H0v17h59V7h-1.5v15.5h-56Z",
    fill: "currentColor"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.25 20a.75.75 0 0 0 .75-.75V4.75a.75.75 0 0 0-1.5 0v14.5c0 .414.336.75.75.75ZM50.75 20a.75.75 0 0 0 .75-.75V4.75a.75.75 0 0 0-1.5 0v14.5c0 .414.336.75.75.75ZM47.25 20a.75.75 0 0 0 .75-.75V4.75a.75.75 0 0 0-1.5 0v14.5c0 .414.336.75.75.75ZM43.75 20a.75.75 0 0 0 .75-.75V4.75a.75.75 0 0 0-1.5 0v14.5c0 .414.336.75.75.75ZM40.25 20a.75.75 0 0 0 .75-.75V4.75a.75.75 0 0 0-1.5 0v14.5c0 .414.336.75.75.75ZM36.75 20a.75.75 0 0 0 .75-.75V4.75a.75.75 0 0 0-1.5 0v14.5c0 .414.336.75.75.75Z",
    fill: "currentColor",
    opacity: 0.2
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.25 16a.75.75 0 0 0 .75-.75V.75a.75.75 0 0 0-1.5 0v14.5c0 .414.336.75.75.75Z",
    fill: "currentColor"
  })), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.134 19.356a.75.75 0 0 0 .274-1.024L5.158 5.775a.75.75 0 1 0-1.299.75l7.25 12.557a.75.75 0 0 0 1.025.274ZM16.433 19.356a.75.75 0 0 0 .274-1.024L9.457 5.775a.75.75 0 1 0-1.299.75l7.25 12.557a.75.75 0 0 0 1.025.274ZM20.65 19.356a.75.75 0 0 0 .274-1.024l-7.25-12.557a.75.75 0 0 0-1.299.75l7.25 12.557a.75.75 0 0 0 1.025.274ZM24.65 19.356a.75.75 0 0 0 .274-1.024l-7.25-12.557a.75.75 0 0 0-1.299.75l7.25 12.557a.75.75 0 0 0 1.025.274Z",
    fill: "currentColor",
    opacity: 0.2
  })));
};
export default SvgFeedVinyl;